import initializeStore from './initializeStore';

const store = initializeStore();

export default store;
